import { render, staticRenderFns } from "./animations.vue?vue&type=template&id=1beda18c&"
import script from "./animations.vue?vue&type=script&lang=js&"
export * from "./animations.vue?vue&type=script&lang=js&"
import style0 from "./animations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports